export default "__VITE_ASSET__Dnk1PTNJ__"